export enum CustomerNameId {
  ID = 'id',
  EMAIL = 'email',
  EMAIL_VERIFIED = "emailVerified",
  IS_DELETED = 'isDeleted',
  CREATED_AT = 'createdAt',
}


